import { Facility } from './facility.model';
import { JobTitle } from './job-title.model';
import { Measure } from './measure.model';
import { User } from './user.model';
import { VarianceReason } from './variance-reason.model';
import { InpatientConfiguration } from './inpatient-configuration.model';
import { AncillaryConfiguration } from './ancillary-configuration.model';
import { StaffRatioValue } from './staff-ratio-value.model';

export class CostCenter {    
    id: number;    
    clientId: number;
    errorMessage: string;
    facility: Facility;
    name: string;
    number: string;
    costCenterType: string;
    inpatientConfiguration: InpatientConfiguration;
    ancillaryConfiguration: AncillaryConfiguration;
    fixedJobTitles: JobTitle[];
    jobTitles: JobTitle[];
    includedInRatio: JobTitle[];
    variableJobTitles: JobTitle[];
    measures: Measure[];
    varianceReasons: VarianceReason[];
    users: User[];
    modifiedByUserName: string;
    modifiedDate: Date;
    inactiveDate: Date;
    mostRecent: boolean;
    isRFVOrderUpdated: boolean;
    isJTOrderUpdated: boolean;
    isMeasuresOrderUpdated: boolean;
    isUserUpdated: boolean;
}

